import { render } from "./areaTeaXbEchart.vue?vue&type=template&id=520c38f1&scoped=true"
import script from "./areaTeaXbEchart.vue?vue&type=script&lang=js"
export * from "./areaTeaXbEchart.vue?vue&type=script&lang=js"

import "./areaTeaXbEchart.vue?vue&type=style&index=0&id=520c38f1&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520c38f1"]])

export default __exports__